(function () {
  'use strict';

  /* @ngdoc object
   * @name message
   * @description
   *
   */
  angular
    .module('message', [
      'ui.router'
    ]);
}());
